<template>
  <pt-refund-order-list class="pt-refund-order-list__page"></pt-refund-order-list>
</template>

<script>
import PtRefundOrderList from 'cps/goods-order/pt-refund-order-list/withData'
export default {
  name: 'pt-refund-order-list__view',
  components: {
    'pt-refund-order-list': PtRefundOrderList
  }
}
</script>
